module.exports = __webpack_public_path__ + "static/media/10.d98ca956.jpg";